import React, { Component, Fragment } from 'react';
import { Row, Col, Input, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class TeamResponsibilities extends Component {
    constructor(props) {
        super(props);
        const selector = this.props.selector != null ? this.props.selector.split('/') : '';
        this.state = {
            data: [],
            sheetData: [],
            selectedTeam: selector !== '' && selector[0] != null && selector[0] !== '' ? (selector[0]) : 0,
            selectedFrequency: this.props.selector !== '' && selector[1] != null && selector[1] !== '' ? (selector[1]) : 0,
        };
    }

    componentDidMount() {
        this.props.log('TeamResponsibilities.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('TeamResponsibilities.js/onSubmit');
        fetch('/api/reports/TeamResponsibilities', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data.map(item => { return { ...item, clients: item.clients != null ? JSON.parse(item.clients) : null } })
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChange = (e) => {
        this.props.log('TeamIndividualResponsibilities.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.setState({
            // selector: e.target.value,
            [e.target.name]: (e.target.value)
        }, () => {
            this.getCSVdata();
            this.props.changeSelector({ target: { value: this.state.selectedTeam + '/' + this.state.selectedFrequency } });
        });
    }

    getCSVdata = () => {
        this.props.log('TeamResponsibilities.js/getCSVdata');
        let retArr = [];
        let data = [];
        if (this.state.selectedTeam !== 0) {
            data = (this.state.selectedTeam != null && this.state.selectedTeam !== '') ? this.state.data.filter(team => team.team === this.state.selectedTeam) : this.state.data.filter(team => team.team == null);
            data.forEach(team => {
                // const maxClients = team.clients != null ? team.clients.length : 0;
                // const maxTasks = team.clients != null ? team.clients.reduce((previous, current) => previous + (current.tasks != null ? (current.tasks.length - 1) : 0), 0) : 0;
                // const maxLength = maxClients + maxTasks + 4;
                let teamArr = [['', '', '', '', ''], [], []];// [...Array(maxLength)].map(row => ['', '', '', '', '']);
                teamArr[0][0] = team.team != null ? team.team : 'No Team';
                teamArr[2][0] = 'Clients';
                if (team.clients != null && team.clients.length > 0 && team.clients[0].teamName != null) {
                    teamArr[2][1] = 'Team';
                    teamArr[2][2] = 'Tasks';
                    teamArr[2][3] = 'Frequency';
                    teamArr[2][4] = 'Est. Start Time';
                    teamArr[2][5] = 'Est. End Time';
                } else {
                    teamArr[2][1] = 'Tasks';
                    teamArr[2][2] = 'Frequency';
                    teamArr[2][3] = 'Est. Start Time';
                    teamArr[2][4] = 'Est. End Time';
                }
                if (team.clients != null) {
                    team.clients.filter(client => (this.state.selectedFrequency != null && this.state.selectedFrequency !== '0' && this.state.selectedFrequency !== '') ?
                        (client.tasks != null) : true)
                        .forEach((client, clientIndex) => {
                            if (client.tasks != null) {
                                client.tasks
                                    .filter(task => (this.state.selectedFrequency != null && this.state.selectedFrequency !== '0' && this.state.selectedFrequency !== '') ?
                                        (task.duration === parseInt(this.state.selectedFrequency) && task.duration != null && task.duration !== 0 && task.duration !== '') : true)
                                    .forEach((task, taskIndex) => {
                                        let row = [];
                                        row[0] = (taskIndex === 0) ? client.name : '';
                                        if (client.teamName != null) {
                                            row[1] = (taskIndex === 0) ? client.teamName : '';
                                            row[2] = task.name;
                                            row[3] = this.getDuration(task.duration);
                                            row[4] = this.getTime(task.estimatedBeginTime);
                                            row[5] = this.getTime(task.estimatedEndTime);
                                        } else {
                                            row[1] = task.name;
                                            row[2] = this.getDuration(task.duration);
                                            row[3] = this.getTime(task.estimatedBeginTime);
                                            row[4] = this.getTime(task.estimatedEndTime);
                                        }
                                        // row[5] = task.estimatedDuration; */}
                                        teamArr.push(row);
                                    })
                            } else if (client.name !== '') {
                                if (client.teamName != null) {
                                    teamArr.push([client.name, client.teamName, '', '', '', ''])
                                } else {
                                    teamArr.push([client.name, '', '', '', ''])
                                }
                            }
                        })
                }
                retArr = retArr.concat(teamArr);
            });
        }
        // console.log(retArr);
        this.props.passData(retArr, "team-responsibilities_team-" + (this.state.selectedTeam === -1 ? 'not-set' : this.state.selectedTeam));
    }

    getTime = (time) => {
        if (time == null || time === '') return '';
        var hours = parseInt(time.substring(0, 2)),
            minutes = parseInt(time.substring(3, 5)),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + String(minutes).padStart(2, '0') + ' ' + ampm;
    }

    getDuration = (val) => {
        switch (val) {
            case 24:
                return 'Daily';
            case 730:
                return "Monthly";
            case 2190:
                return "Quarterly";
            case 8760:
                return "Annually";
            default:
                return '--';
        }
    }

    render() {
        this.props.info('TeamResponsibilities.js/render');
        let data = [];
        if (this.state.selectedTeam !== 0) {
            data = (this.state.selectedTeam != null && this.state.selectedTeam !== '') ? this.state.data.filter(team => team.team === this.state.selectedTeam) : this.state.data.filter(team => team.team == null);
        } else {
            data = this.state.data;
        }
        // console.log(data);
        return (
            <><Row className="mt-4">
                <Col md={4}>
                    <Input type="select"
                        name="selectedTeam"
                        onChange={(e) => this.onChange(e)}
                        value={this.props.isFieldNull(this.state.selectedTeam)}
                    >
                        <option value="0">SELECT TEAM</option>
                        {[...this.state.data].map(team => { return team.team != null ? (team.team) : -1 }).map((team, teamIndex) => (
                            <option key={teamIndex}
                                value={this.props.isFieldNull(team)}>{team === -1 ? 'Team Not Set' : team}</option>
                        ))}
                    </Input>
                </Col>
                <Col md={4}>
                    <Input type="select"
                        name="selectedFrequency"
                        onChange={(e) => this.onChange(e)}
                        value={this.props.isFieldNull(this.state.selectedFrequency)}
                    >
                        <option value="0">SELECT FREQUENCY</option>
                        <option value="24">Daily</option>
                        <option value="730">Monthly</option>
                        <option value="2190">Quarterly</option>
                        <option value="8760">Annually</option>
                    </Input>
                </Col>
            </Row>
                <>{data.map((team, teamIndex) => (
                    <Fragment key={teamIndex}>
                        {(this.state.selectedTeam === 0) ? <></> :
                            <>
                                <Row className="mt-4">
                                    <Col md={12}>
                                        <h2>{team.team != null ? team.team : 'No Team'}</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <h3>Clients and Tasks</h3>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Client</th>
                                                    {team.clients != null && team.clients.length > 0 && team.clients[0].teamName != null ? <th>Team</th> : null}
                                                    <th>Task</th>
                                                    <th>Frequency</th>
                                                    <th>Est. Start Time</th>
                                                    <th>Est. End Time</th>
                                                    {/* <th>Est. Duration</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {team.clients != null ? team.clients
                                                    .filter(client => (this.state.selectedFrequency != null && this.state.selectedFrequency !== '0' && this.state.selectedFrequency !== '') ?
                                                        (client.tasks != null) : true)
                                                    .map((client, clientIndex) => (
                                                        client.tasks != null ? <Fragment key={clientIndex}>{client.tasks
                                                            .filter(task => (this.state.selectedFrequency != null && this.state.selectedFrequency !== '0' && this.state.selectedFrequency !== '') ?
                                                                (task.duration === parseInt(this.state.selectedFrequency) && task.duration != null && task.duration !== 0 && task.duration !== '') : true)
                                                            .map((task, taskIndex) => (
                                                                <tr key={taskIndex}>
                                                                    {taskIndex === 0 ? <td>{client.name}</td> : <td></td>}
                                                                    {client.teamName != null && taskIndex === 0 ? <td>{client.teamName}</td> : <td></td>}
                                                                    <td>{task.name}</td>
                                                                    <td>{this.getDuration(task.duration)}</td>
                                                                    <td>{this.getTime(task.estimatedBeginTime)}</td>
                                                                    <td>{this.getTime(task.estimatedEndTime)}</td>
                                                                    {/* <td>{task.estimatedDuration}</td> */}
                                                                </tr>
                                                            ))}</Fragment> :
                                                            <tr key={clientIndex}>
                                                                <td>{client.name}</td>
                                                                {client.teamName != null ? <td>{client.teamName}</td> : null}
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                {/* <td></td> */}
                                                            </tr>
                                                    )) :
                                                    <></>
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </>
                        }
                    </Fragment>
                ))}</>
            </>
        );

    }
}

export default TeamResponsibilities;
